import { Injectable } from '@angular/core';
import { WebSocketSubject } from 'rxjs/webSocket';
import * as crypto from 'crypto-js';
import { Subject } from 'rxjs';

import { AuthService } from '../auth.service';
import { AppService } from '../app.service';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WebsocketService {
  private _api = environment.chat;
  private _usertoken: string;
  private _key = 'dve-dating-chat-ZgRffh74p7FeQfVD';
  private _iv = 'uinbha458750987y';

  private ws$!: WebSocketSubject<unknown>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private message$ = new Subject<any>();
  private room: number | string | null = null;
  private closing = false;

  constructor(
    private authService: AuthService, 
    private appService: AppService
  ) {
    this._usertoken = authService.get('token');
  }

  serviceId = Number(this.appService.serviceId)
  private ws: WebSocket | null= null;

  get token() {
    const t = crypto.AES.encrypt(this._usertoken, this._key, {
      iv: CryptoJS.enc.Hex.parse(this._iv),
    });

    return t;
  }

  connect(
    talkingId: number,
    message?: { userId: number; value: string; photo?: string } | null,
    roomToken?: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    el?: any,
  ) {
    console.log('ws connect')
    this.room = talkingId
    const self = el ? el : this
    this.closing = false

    if (!self.ws) {
      self.ws = new WebSocket(`wss://${this._api}?serviceId=${self.serviceId}&token=${self.authService.get('token')}`)

      self.ws.onopen = () => {
        console.log('ws is open')

        self.ws.send(
          JSON.stringify({
            action: 'joinroom',
            serviceId: self.serviceId,
            room: talkingId,
            token: roomToken,
          })
        )

        if (message) {
          //console.log(message)
          if (message.photo) {
            if(!this.room || typeof this.room === 'string') return
            this.sendPhotoMessage(this.room, message.photo, message.value)
          }

          if(!this.room) return
          this.sendMessage(this.room.toString(), message.userId, message.value)
        }
      };
    }

    console.log('websocket state', self.ws.readyState)

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    self.ws.onclose = (e: any) => {
      console.log('Socket is closed. Reconnection will be attempted in 1 second.', e.reason)
      self.ws = null

      if (!this.closing) {
        setTimeout(() => {
          self.connect(talkingId, roomToken, self)
        }, 1000);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    self.ws.onerror = (err: any) => {
      console.error('Socket encountered error: ', err, 'Closing socket')
      self.ws = null

      setTimeout(() => {
        self.connect(talkingId, roomToken, self)
      }, 1000)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    self.ws.onmessage = (event: any) => {
      self.message$.next(event)
    };
  }

  sendMessage(room: string, relatedUserId: number, msg: string) {
    console.log('sendMessage')
    if (this.ws && this.ws.readyState === 1) {
      this.ws.send(
        JSON.stringify({
          action: 'sendmessage',
          serviceId: this.appService.serviceId,
          method: 'POST',
          route: '/message',
          room,
          headers: {
            Accept: 'application/x.nda.v4+json',
            Authorization: `Bearer ${this.authService.get('token')}`,
            'Content-Type': 'application/json',
          },
          postdatas: {
            related_user_id: relatedUserId,
            content: msg,
          },
        })
      );
    } else {
      console.log('Socket is closed. Reconnection will be attempted in 1 second.');
      setTimeout(() => this.connect(parseInt(room), { userId: relatedUserId, value: msg }), 1000);
    }
  }

  close(room: string) {
    this.closing = true
    // this.subscription.unsubscribe();
    if(!this.ws) return
    this.ws.send(
      JSON.stringify({
        action: 'leaveroom',
        serviceId: this.appService.serviceId,
        room,
      })
    );
    this.ws.close()
    this.ws = null
  }

  sendPhotoMessage(id: number, b64: string, msg: string) {
    if(!this.ws) return
    
    this.ws.send(
      JSON.stringify({
        action: 'sendmessage',
        serviceId: this.appService.serviceId,
        method: 'POST',
        route: '/photo',
        room: id,
        headers: {
          Accept: 'application/x.nda.v6+json',
          Authorization: `Bearer ${this.authService.get('token')}`,
          'Content-Type': 'application/json',
        },
        postdatas: {
          mime_type: 'jpeg',
          type: 'message',
          talking_id: id,
          content: msg,
        },
      })
    )
  }

  get message() {
    return this.message$.asObservable()
  }

  set message(value) {
    this.message$.next(value)
  }

  send(msg: string) {
    this.ws$.next(msg)
  }
}
